import * as React from "react"
import Svg, { Defs, G, Path } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: style */

function EnlargeIcon(props) {
  return (
    <Svg viewBox="0 0 166.52 166.02" {...props}>
      <Defs></Defs>
      <G id="prefix__Layer_2" data-name="Layer 2">
        <G id="prefix__Layer_1-2" data-name="Layer 1">
          <Path
            className="prefix__cls-1"
            d="M123 63.18A59.82 59.82 0 1163.18 3.36 59.82 59.82 0 01123 63.18z"
          />
          <Path
            className="prefix__cls-1"
            d="M99.34 110.64l51.47 52.01 12.35-12.71-51.53-51.69M63.18 33.1v60.16M33.1 63.18h60.16"
          />
        </G>
      </G>
    </Svg>
  )
}

export default EnlargeIcon
